import type { TrackingAttribute } from './types';

//TODO: this is copy from the wordpress project, will need to refactor later to work with this project

/**
 * Determines the CTA type based on the content within a module element
 * @param element - The DOM element to analyze for CTA content
 * @returns The CTA type: 'enrollment', 'engagement', or 'No CTA'
 */
export const getModuleCTAType = (element: HTMLElement): string => {
  // Check for enrollment-related elements
  const hasEnrollLink = !!element.querySelector('a[href*="/enroll"]');

  // Check for email capture elements
  const hasEmailCapture = !!element.querySelector('input[name="email"]');

  if (hasEnrollLink || hasEmailCapture) {
    return 'enrollment';
  }

  // Check for any links (engagement)
  const hasAnyLink = !!(
    element.querySelector('a[href]') ||
    element.querySelector('button') ||
    element.querySelector('[role="button"]')
  );

  return hasAnyLink ? 'engagement' : 'No CTA';
};

export function convertObjectToArray(obj: Record<string, string | number | undefined>): TrackingAttribute[] {
  return Object.entries(obj).map(([key, value]) => ({
    key: key.replace(/([A-Z])/g, '_$1').toLowerCase(),
    value,
  }));
}

export function getAdditionalTrackingProperties(): Record<string, string | undefined> {
  // Detects the browser at runtime; there is no value to parse at a boundary here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  if (typeof document === 'undefined') return {};

  // Keyed by a name computed at runtime, so the index signature is the contract.
  // oxlint-disable-next-line anti-slop/no-known-value-widening
  return {
    fbc: getCookieValue('_fbc'),
    fbp: getCookieValue('_fbp'),
  };
}

export function getCookieValue(name: string): string | undefined {
  // Detects the browser at runtime; there is no value to parse at a boundary here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }
  return undefined;
}
